module.exports = __webpack_public_path__ + "static/media/no.6ff2f0cc.svg";